// install (please make sure versions match peerDependencies)
// yarn add @nivo/core @nivo/heatmap
import { ResponsiveHeatMap /*ComputedCell*/ } from '@nivo/heatmap';

/*
const CustomCell = ({
    cell,
    borderWidth,
}: {
    cell: ComputedCell<any>;
    borderWidth: number;
}) => {
    console.log(cell);
    if (cell.value === null)
        return (
            <g
                transform={`translate(${cell.x}, ${cell.y})`}
                style={{ cursor: 'pointer' }}
                opacity={cell.opacity}
            >
                <rect
                    transform={`translate(-${cell.width / 2}, -${
                        cell.height / 2
                    })`}
                    fill={'#FFFFFF'}
                    fillOpacity={cell.opacity}
                    strokeWidth={borderWidth}
                    stroke={cell.borderColor}
                    width={cell.width}
                    height={cell.height}
                />
            </g>
        );

    return (
        <g
            transform={`translate(${cell.x}, ${cell.y})`}
            style={{ cursor: 'pointer' }}
            opacity={cell.opacity}
            data-testid={`cell.${cell.id}`}
        >
            <rect
                transform={`translate(-${cell.width / 2}, -${cell.height / 2})`}
                fill={cell.color}
                fillOpacity={cell.opacity}
                strokeWidth={borderWidth}
                stroke={cell.borderColor}
                width={cell.width}
                height={cell.height}
                rx="0"
                ry="0"
            />
            <text
                dominantBaseline="central"
                textAnchor="middle"
                style={{ fill: cell.labelTextColor }}
            >
                {cell.formattedValue}
            </text>
        </g>
    );
};*/
//cellComponent={CustomCell}

// make sure parent container have a defined height when using
// responsive component, otherwise height will be 0 and
// no chart will be rendered.
// website examples showcase many properties,
// you'll often use just a few of them.
export function HeatMap(props: any) {
    return (
        <ResponsiveHeatMap
            data={props.data}
            margin={{ top: 30, right: 0, bottom: 0, left: 0 }}
            valueFormat={props.format}
            axisTop={{
                tickSize: 5,
                tickPadding: 5,
            }}
            axisRight={null}
            axisLeft={null}
            colors={{
                type: 'diverging',
                scheme: 'blues',
                minValue: props.min,
                maxValue: props.max,
                divergeAt: 1,
            }}
            labelTextColor={{
                from: 'color',
                modifiers: [['darker', 3]],
            }}
            theme={{ fontSize: 13 }}
            emptyColor="#555555"
        />
    );
}
